<template>
    <div>
        <el-button size="mini" type="primary" @click="handleEdit" style="margin-right: 10px;">
            编辑
        </el-button>
        <el-popconfirm title="确定删除吗？" @confirm="handleDelete">
            <el-button size="mini" type="danger" slot="reference">删除</el-button>
        </el-popconfirm>
    </div>
</template>

<script>
export default {
    name: "ActionButtons",
    methods: {
        handleEdit() {
            this.$emit('tableedit')
        },
        handleDelete() {
            // 假设删除操作需要传递 ID，可根据实际需求调整
            this.$emit('tabledel')

        }
    }
};
</script>